// src/utils/logger.js

const logger = {
  log: (...args) => {
    // Only log in development environment
    if (process.env.NODE_ENV === 'development') {
      console.log(...args);
    }
  },
  error: (...args) => {
    // Log errors in all environments (development and production)
    // You might want to integrate a proper error tracking service in production
    console.error(...args);
  },
  warn: (...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn(...args);
    }
  },
  info: (...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.info(...args);
    }
  },
};

export default logger;